import { useEffect } from "react";

/**
 * Set document.title to "VendeIA · {title}" while this component is mounted.
 * Restores the previous title on unmount so navigating away doesn't strand
 * a stale tab label.
 *
 *   useDocumentTitle("Inventario");
 *   useDocumentTitle(`Producto · ${product?.nombre}`);
 *
 * Passing a falsy title sets the bare brand "VendeIA" — useful for loading
 * states where the page-specific title isn't ready yet.
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `VendeIA · ${title}` : "VendeIA";
    return () => {
      document.title = previous;
    };
  }, [title]);
}
